import React, { useState, useEffect } from 'react';
import './CookieConsent.css';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check local storage on site load to see if user already chose
    const consent = localStorage.getItem('tronixConsent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('tronixConsent', 'accepted');
    setShowBanner(false);
    // Here you would typically initialize analytics scripts
  };

  const handleReject = () => {
    localStorage.setItem('tronixConsent', 'rejected');
    setShowBanner(false);
    // Ensure non-essential cookies are blocked
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-content">
        <p>
          We use cookies to improve your experience and analyze website traffic. By clicking “Accept”, you agree to our use of cookies as described in our Privacy Policy. You can reject non-essential cookies.
        </p>
      </div>
      <div className="cookie-buttons">
        <button onClick={handleReject} className="btn-cookie btn-reject">Reject</button>
        <button onClick={handleAccept} className="btn-cookie btn-accept">Accept</button>
      </div>
    </div>
  );
};

export default CookieConsent;